import { loginService, signupService, enumsService } from './AuthServices';
export type { ILoginServiceRequest, ISignupServiceRequest } from './IAuthServices';

export const AuthService = { loginService, signupService, enumsService };
